module.exports = __webpack_public_path__ + "img/service-warehouse.0e9d2e70.jpg";